<p-floatLabel>
  <p-select #answerGroupDropdown
    id="answerGroupDropdown"
    name="answerGroupDropdown"
    [options]="answerGroups"
    [(ngModel)]="answerGroup"
    [showClear]="!isRequired"
    [checkmark]="true"
    [filter]="true"
    [filterBy]="'name'"
    [optionLabel]="'name'"
    [appendTo]="'body'"
    styleClass="w-100"
    optionLabel="name"
    (onChange)="onSelected()"
    (onClick)="$event.stopPropagation()">
    <ng-template let-option pTemplate="item">
      {{ option.name }}
    </ng-template>
  </p-select>
  <label for="answerGroupDropdown">
    <app-label-content [isRequired]="isRequired">
      {{ l('::AnswerGroup') }}
    </app-label-content>
  </label>
</p-floatLabel>
